"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const fa_1 = require("react-icons/fa");
const fi_1 = require("react-icons/fi");
const IconMap = {
    googlePay: { icon: fa_1.FaGooglePay },
    applePay: { icon: fa_1.FaApplePay },
    creditCard: { icon: fi_1.FiCreditCard, size: 25 }
};
exports.default = ({ type }) => {
    var _a, _b;
    if (type == "none")
        return React.createElement(React.Fragment, null);
    const iconDetails = IconMap === null || IconMap === void 0 ? void 0 : IconMap[type];
    const MyIcon = iconDetails === null || iconDetails === void 0 ? void 0 : iconDetails.icon;
    console.log(type);
    if (!MyIcon)
        return null;
    const overrides = (_a = iconDetails.styles) !== null && _a !== void 0 ? _a : {};
    return React.createElement(MyIcon, { size: (_b = iconDetails.size) !== null && _b !== void 0 ? _b : 34, style: overrides });
};
//# sourceMappingURL=PaymentIcon.js.map